import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const treatments = [
    'PRP Hair Restoration',
    'PRP Skin Rejuvenation',
    'Micro-needling',
    'Botox Injectables',
    'Dermal Fillers',
    'Post Hair Transplant Treatments',
];

// EmailJS credentials
const SERVICE_ID = 'service_8puiiu9';
const TEMPLATE_ID = 'template_955wk8m';
const PUBLIC_KEY = 'lJcPvNT6gjkEUYLbL';

const Contact = ({ onSuccess }) => {
    const [form, setForm] = useState({
        firstName: '', lastName: '', email: '', phone: '', treatment: '', message: '',
    });
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = e => {
        e.preventDefault();
        setSending(true);
        setError('');

        const templateParams = {
    from_name: `${form.firstName} ${form.lastName}`,
    from_email: form.email,
    from_phone: form.phone,
    treatment: form.treatment,
    message: form.message,
    reply_to: form.email,
};

        emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
            .then(() => {
                setSending(false);
                // This calls the handleFormSuccess function in App.js
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                // Resets the form fields
                setForm({ firstName: '', lastName: '', email: '', phone: '', treatment: '', message: '' });
            })
            .catch(err => {
                setSending(false);
                setError('Something went wrong. Please try again or contact us by phone.');
                console.error('EmailJS error:', err);
            });
    };

    return (
        <section className="contact-section" id="contact">
            <div className="container contact-inner">
                <div className="contact-info">
                    <span className="section-tag">Get in Touch</span>
                    <h2 className="section-title">Let's Start Your Journey to Confidence</h2>

                    <div className="contact-details">
                        <h4>Get Consultation</h4>
                        <div className="contact-item">
                            <span className="contact-icon">📞</span>
                            <a href="tel:+14694341574">Phone : +1 469-434-1574</a>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📍</span>
                            <a href="https://maps.google.com" target="_blank" rel="noreferrer">
                                Location : 8200 Liberty Grove Rd Suite #103, Rowlett, TX 75089, United States
                            </a>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">✉️</span>
                            <a href="mailto:embracebeautyaesthetics@gmail.com">embracebeautyaesthetics@gmail.com</a>
                        </div>
                    </div>

                    <div className="open-hours">
                        <h4>Open Hours</h4>
                        <p>Mon – Sun : 9 AM to 5 PM</p>
                    </div>
                </div>

                <div className="contact-form-wrap">
                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>First Name</label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={form.firstName}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={form.lastName}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="Email Address"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    placeholder="Phone Number"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Select Your Treatment of Interest</label>
                            <select name="treatment" value={form.treatment} onChange={handleChange}>
                                <option value="">Select Treatment</option>
                                {treatments.map((t, i) => (
                                    <option key={i} value={t}>{t}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Message</label>
                            <textarea
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                placeholder="Your message..."
                                rows="5"
                            />
                        </div>

                        {error && <p className="form-error">{error}</p>}

                        <button type="submit" className="btn-primary submit-btn" disabled={sending}>
                            {sending ? 'Sending...' : 'Contact Us'}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Contact;